import styled, { css } from "styled-components"

const ContentParagraph = styled.p`
  /* font-size: clamp(0.7rem, 0.1rem + 1vw, 1.2rem);  */
  font-size: ${({ fontSize }) =>
    fontSize ? fontSize : "16px"}; /* to verivy */
  color: ${props => (props.color ? props.color : props.theme.color.black)};
  text-align: center;
  margin-bottom: 50px;
  font-family: "sharp_grotesklight_20", sans-serif;
  line-height: 1.94;
    
    a {
        color: #000;
        text-decoration: none;
        font-weight: 500;
        
        &:hover {
            text-decoration: underline;
        }
    }
    
  span {
    font-weight: 800;
  }
  ${({ sign }) =>
    sign &&
    css`
      text-align: right;
    `}
  ${({ mb0 }) =>
    mb0 &&
    css`
      margin-bottom: 0;
    `}
    ${({ typeTitle }) =>
      typeTitle &&
      css`
        font-size: ${({ fontSize }) => (fontSize ? fontSize : "24px")};
        font-family: "sharp_grotesksemibold_25", sans-serif;
      `}
      ${({ medium }) =>
        medium &&
        css`
          font-family: "sharp_groteskmedium_20";
        `}
`
export { ContentParagraph }
